/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 15:49:21
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchTermsAndCondition } from 'src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import css from './css.module.less';

const CloneBtn = () => {
  const params: any = useParams();
  const { TcUuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      fetchTermsAndCondition({
        //1===true 0===false
        uuid: TcUuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        },
        isClone: true,
      }),
    );
  };
  return (
    <div className={css.container}>
      <Button
        onClick={handleOnClick}
        btnClassName={css.btn}
        className={css.innerContainer}
      />
    </div>
  );
};
export default CloneBtn;
